import { render, staticRenderFns } from "./play-h5.vue?vue&type=template&id=2ed6ac9c&"
import script from "./play-h5.vue?vue&type=script&lang=js&"
export * from "./play-h5.vue?vue&type=script&lang=js&"
import style0 from "./play-h5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports